import { defineAction } from '~/prix'
import inventoryMockAction from './inventoryMock.action.json' with { type: 'json' }
import { z } from 'zod'

const inventoryMockDefinition = defineAction({
  ...inventoryMockAction,

  input: z.object({
    count: z.number().default(50),
    seed: z.number().default(10),
  }),
  output: z.object({}),
})

export default inventoryMockDefinition
